import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7bf8cf28"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionsWWLeadershipOverlays: require('/opt/build/repo/components/Sections/WW/Leadership/Overlays.vue').default,LayoutSectionHeader: require('/opt/build/repo/components/Layout/SectionHeader/index.vue').default,SectionsWWLeadershipTrust: require('/opt/build/repo/components/Sections/WW/Leadership/Trust.vue').default,SectionsWWLeadershipScience: require('/opt/build/repo/components/Sections/WW/Leadership/Science.vue').default,SectionsWWLeadershipNetwork: require('/opt/build/repo/components/Sections/WW/Leadership/Network.vue').default})
